import { render, staticRenderFns } from "./CurrentDownloadsItem.vue?vue&type=template&id=0a0cd3ae&"
import script from "./CurrentDownloadsItem.vue?vue&type=script&lang=js&"
export * from "./CurrentDownloadsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports